import { Inject, Injectable } from '@angular/core';

import { EnvironmentToken } from '../../util';
import { Environment } from '../../typings';

export enum TalentAppFeatures {
  AGE_GROUP = 'age-group-feature',
  CUSTOM_VETTING_QUESTIONS = 'custom-vetting-questions-feature',
  PRE_INTERVIEW_QUESTIONS = 'pre-interview-questions-feature',
  AI_GENERATED_PRE_INTERVIEW_QUESTIONS = 'ai-generated-pre-interview-questions-feature',
  APPLICANT_PAY_TRANSPARENCY_FEATURE = 'applicant-pay-transparency'
}
export interface SimpleFeature {
  name: string;
  val: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class FeatureService {
  featureNames: string[] = Object.values(TalentAppFeatures);
  features: SimpleFeature[] = [];

  constructor(@Inject(EnvironmentToken) private environment: Environment) {
    this.featureNames.forEach(name => {
      const val = this.environment.features[name];
      this.features.push({ name, val });
    });
  }

  // Returns all active features
  getActiveFeatures(): SimpleFeature[] {
    return this.features.filter(feat => feat.val);
  }

  // Returns all features, and their status
  getAllFeatures(): SimpleFeature[] {
    return this.features.map(feat => {
      if (!feat.val) {
        feat.val = false;
      }
      return feat;
    });
  }

  // Return status of specific feature
  getFeature(val: string): boolean {
    return this.getAllFeatures().find(feat => feat.name === val).val;
  }
}
